module.exports = __webpack_public_path__ + "img/dp-jy-qt5.a1b06410.png";